import { render } from "./NImageViewerROILayer.vue?vue&type=template&id=62712597&ts=true"
import script from "./NImageViewerROILayer.vue?vue&type=script&lang=ts"
export * from "./NImageViewerROILayer.vue?vue&type=script&lang=ts"

import "./NImageViewerROILayer.vue?vue&type=style&index=0&id=62712597&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__